import { render, staticRenderFns } from "./ygbOrder.vue?vue&type=template&id=5a45046b&scoped=true"
import script from "./ygbOrder.vue?vue&type=script&lang=js"
export * from "./ygbOrder.vue?vue&type=script&lang=js"
import style0 from "./ygbOrder.vue?vue&type=style&index=0&id=5a45046b&prod&lang=css"
import style1 from "./ygbOrder.vue?vue&type=style&index=1&id=5a45046b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a45046b",
  null
  
)

export default component.exports